'use strict';

module.exports = {
    active: 0,
    shortNames: null,
    fullNames: null,
    codes: null,
    supportedShortNames: ['Eng', 'Рус', 'Укр', 'Deu', 'Fra', 'Es', 'Et', 'Lat'],
    supportedFullNames: ['English', 'Русский', 'Український', 'Deutsch', 'Français', 'Español', 'Eesti keel', 'Latviešu'],
    supportedCodes: ['en', 'ru', 'uk', 'de', 'fr', 'es', 'et', 'lv'],
    currentProvider: null
};
